﻿export const adminStrings = {
    loading: 'Loading collections...',
    signedOut: 'Sign in to manage the site.',
    loginFailed: 'The username or password is incorrect.',
    requestFailed: 'The request could not be completed.',
    telemetryLoading: 'Loading website traffic...',
    telemetryUnavailable: 'Website traffic is temporarily unavailable.',
    telemetryNoData: 'No traffic recorded for this period.',
    telemetryNoActiveSessions: 'No sessions are currently active.',
    telemetryDirectReferrer: 'Direct / unknown',
    telemetryUpdated: (time: string) => `Updated ${time} UTC`,
    telemetryPeriods: {
        today: 'Today (UTC)',
        '7days': 'Rolling 7 days',
        '30days': 'Rolling 30 days'
    },
    excludeMyVisits: 'Exclude my visits',
    visitsHidden: 'Your visits are hidden',
    excludeDialogTitle: 'Exclude your visits',
    excludeDialogDescription: 'Traffic from this browser is hidden from statistics while excluded. You can include it again at any time.',
    excludeLabelPlaceholder: 'Label (optional)',
    excludeConfirm: 'Exclude',
    excludeCancel: 'Cancel',
    excludedBrowsersHeading: 'Excluded browsers',
    excludedBrowsersEmpty: 'No browsers are excluded.',
    includeAgain: 'Include again',
    excludedOn: (date: string) => `Excluded ${date}`,
    excludeSessionBrowser: 'Exclude browser',
    noCollections: 'No collections have been created.',
    noImages: 'No images have been uploaded.',
    defaultLabel: 'Default collection',
    setDefault: 'Set as default',
    publicLabel: 'Public',
    privateLabel: 'Private',
    visibilityLabel: (name: string) => `Collection visibility for ${name}`,
    defaultVisibilityLocked: 'The default collection is always public.',
    createPrivateLabel: 'Private collection',
    editCollectionName: (name: string) => `Edit collection name ${name}`,
    editCollectionSlug: (slug: string) => `Edit collection slug ${slug}`,
    deleteCollection: 'Delete collection',
    confirmCollectionDelete: (name: string) => `Delete the collection “${name}” and all of its images? This cannot be undone.`,
    editNamedCollection: (name: string) => `Edit ${name}`,
    collectionThumbnail: (name: string) => `${name} collection thumbnail`,
    insightsTeaser: (title: string) => `Most attention this month: ${title}`,
    insightsCollecting: 'Collecting data…',
    ordersToShip: (toShip: number, overdue: number, dueToday: number) => {
        if (toShip === 0) return 'Nothing to ship';
        const urgent = [overdue > 0 ? `${overdue} overdue` : null, dueToday > 0 ? `${dueToday} due today` : null]
            .filter(part => part != null).join(', ');
        return `${toShip} to ship${urgent.length === 0 ? '' : ` · ${urgent}`}`;
    }
} as const;
